import { Component, EventEmitter } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
    templateUrl: "confirmation-modal.component.html",
    standalone: false
})
export class ConfirmationModalComponent {
    title: string = "Confirmation";
    content: string = "Are you sure?";
    submitEvent: EventEmitter<any> = new EventEmitter();

    modalRef: BsModalRef;
    constructor(private bsModalRef: BsModalRef) {
        this.modalRef = bsModalRef;
    }

    onSubmit() {
        this.modalRef.hide();
        this.submitEvent.emit();
    }
}